'use client';

import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface PopupContextType {
  isPopupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  popupType: string | null;
  setPopupType: (type: string | null) => void;
  resetPopup: () => void;
}

const PopupContext = createContext<PopupContextType>({
  isPopupOpen: false,
  setPopupOpen: () => {},
  popupType: null,
  setPopupType: () => {},
  resetPopup: () => {}
});

interface PopupProviderProps {
  children: ReactNode;
}

export const PopupProvider: React.FC<PopupProviderProps> = ({ children }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState<string | null>(null);
  
  const resetPopup = useCallback(() => {
    console.log('🔧 PopupContext reset called');
    setPopupOpen(false);
    setPopupType(null);
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('selectedServiceData');
    }
  }, []);
  
  return (
    <PopupContext.Provider value={{ 
      isPopupOpen, 
      setPopupOpen, 
      popupType, 
      setPopupType,
      resetPopup
    }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);